import { VoidFunctionComponent } from 'react';
import { Text } from '@react-three/drei';
import { monaco } from '@/lib/fonts';
import { BotIcon } from '@/components/BotIcon';
import { useRouterContext } from '@/context/RouterContext';

export const NotFound: VoidFunctionComponent = () => {
    const { navigate } = useRouterContext();
    return (
        <>
            <BotIcon initialScale={0.1} onClick={() => navigate('/magicswan')} />
            <Text font={monaco} textAlign="center" fontSize={0.15} color="white" maxWidth={5} lineHeight={1}>
                Not Found
            </Text>
        </>
    );
};
